export class EditPipelineTrackers {
  /**
   * Wizard
   * */
  static readonly PIPELINE_TRACKER_EDIT_PIPELINE_WIZARD_BACK_CLICK =
    '[Pipelines] edit pipeline wizard back click';

  static readonly PIPELINE_TRACKER_EDIT_PIPELINE_WIZARD_CANCEL_CLICK =
    '[Pipelines] edit pipeline wizard cancel click';

  static readonly PIPELINE_TRACKER_EDIT_PIPELINE_WIZARD_STEP_CLICK =
    '[Pipelines] edit pipeline wizard step click';

  /**
   * Pipeline Settings Step
   * */
  static readonly PIPELINE_TRACKER_EDIT_PIPELINE_PIPELINE_SETTINGS_SAVED_CONFIGURATION =
    '[Pipelines] edit pipeline pipeline settings saved configuration';

  /**
   * Object Config Step
   * */
  static readonly PIPELINE_TRACKER_EDIT_PIPELINE_OBJECT_CONFIG_SAVED_CONFIGURATION =
    '[Pipelines] edit pipeline object configuration saved configuration';

  /**
   * Review Step
   * */
  static readonly PIPELINE_TRACKER_EDIT_PIPELINE_REVIEW_SUBMIT_CLICK =
    '[Pipelines] edit pipeline review submit click';

  static readonly PIPELINE_TRACKER_EDIT_PIPELINE_REVIEW_SUCCESS =
    '[Pipelines] edit pipeline review success';

  static readonly PIPELINE_TRACKER_EDIT_PIPELINE_REVIEW_FAILURE =
    '[Pipelines] edit pipeline review failure';
}
